
import { useTranslation } from 'react-i18next';

import styles from './Text.module.scss';

interface IComponentProperties {
    value: string,
    fontStyle: 
        'body-large' | 'body-medium' | 'body-small' |
        'display-large' | 'display-medium' | 'display-small' |
        'headline-large' | 'headline-medium' | 'headline-small' |
        'label-large' | 'label-medium' | 'label-small' |
        'title-large' | 'title-medium' | 'title-small'
    color?:'on-surface'|'on-surface-variant'
}

export function Text (props: IComponentProperties){

    const { t } = useTranslation();

    const cssModifier = `Text--${props.fontStyle}`;
    const cssColorModifier = props.color? `Text--color-${props.color}`:'' ;

    const textValue = t(props.value);
   
    return (
        <span className={`${styles['Text']} ${styles[cssModifier]} ${styles[cssColorModifier]} `}>
            {textValue}
        </span>
    );

}